import {
  IonAvatar,
  IonButton,
  IonCheckbox,
  IonHeader,
  IonIcon,
  IonImg,
  IonModal,
  IonRouterLink,
  IonRow,
  IonSpinner,
  IonTextarea,
} from "@ionic/react";
import DamageDefault from "../assets/image/damageDefault.png";
import * as d3 from "d3";
import { arrowForward, checkmarkCircleOutline, close } from "ionicons/icons";
import ZoomSvg from "../../assets/svg/zoom.svg";
import TractorLeftSvg from "../../assets/svg/tractorLeft.svg";
import TractorRightSvg from "../../assets/svg/tractorRight.svg";
import TractorFrontSvg from "../../assets/svg/tractorFront.svg";
import { ReactSVG } from "react-svg";

import "./ReportDamageModal.css";
import { useEffect, useState } from "react";
import { tractorMapping } from "../../data/vehicleMapping";
import { Camera, CameraResultType } from "@capacitor/camera";
import { damageReportOptions } from "../../data/FormOptions";
import { useGetDamageTypeQuery } from "../../api/damage";
import { VehiclePart } from "../../types/api/vehiclePart.types";
interface Step3Props {
  side: string;
  type: string;
  setStep: (step: number) => void;
  damageList: { [index: string]: boolean };
  selectedElement: string;
  description: string;
  imageUrl: string;
  setImageUrl: (image: string) => void;
  setSelectedElement: (element: string) => void;
  setDamageList: (list: { [index: string]: boolean }) => void;
  setOpen: (isOpen: boolean) => void;
  setDescription: (des: string) => void;
  setSelectType: (element: string) => void;
  setSelectSide: (element: string) => void;
  storeDamage: () => void;
  vehicleParts: VehiclePart[];
  setCameraIsActive: (element: boolean) => void;
}

const listOptions = [
  {
    label: "Rayures",
    name: "grooves",
  },
  {
    label: "Impacts",
    name: "impacts",
  },
  {
    label: "Élément tordu",
    name: "twistedElement",
  },
  {
    label: "Élément enfoncé",
    name: "pressedElement",
  },
];

const Step4: React.FC<Step3Props> = ({
  side,
  type,
  setStep,
  selectedElement,
  damageList,
  description,
  imageUrl,
  setImageUrl,
  setOpen,
  setDamageList,
  setDescription,
  setSelectedElement,
  setSelectType,
  setSelectSide,
  storeDamage,
  vehicleParts,
  setCameraIsActive,
}) => {
  const [finishModalIsOpen, setFinishModalIsOpen] = useState(false);
  const [storeLoading, setStoreLoading] = useState(false);
  let vehiclePart = vehicleParts.filter(
    (el) => el.code === selectedElement
  )?.[0];

  const { data: damagesType, isLoading: damageLoading } = useGetDamageTypeQuery(
    {
      page: "1",
      itemsPerPage: "50",
      vehiclePartId: vehiclePart?.id,
    }
  );

  let damageTypeOptions: { label: string; name: string }[] = [];
  if (!damageLoading) {
    damageTypeOptions =
      damagesType?.map((el) => {
        return {
          label: el.title,
          name: el.id,
        };
      }) || [];
  }

  const takePicture = async () => {
    setCameraIsActive(true);
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.DataUrl,
      correctOrientation: true,
    });
    setCameraIsActive(false);
    var imageUrl = image.webPath;

    setImageUrl(image.dataUrl!);
  };

  useEffect(() => {
    if (finishModalIsOpen) {
      setTimeout(() => {
        setFinishModalIsOpen(false);
        setImageUrl("");

        setDamageList({});
        setDescription("");
        setSelectedElement("");
        setOpen(false);
        setStep(side === "Inside" || side === "TrailerInside" ? 1 : 0);
      }, 2000);
    }
  }, [finishModalIsOpen]);
  return (
    <>
      <IonModal
        isOpen={finishModalIsOpen}
        initialBreakpoint={1}
        breakpoints={[0, 1]}
      >
        {" "}
        <div className="ReportDamageModal-step4-end">
          <IonIcon
            src={checkmarkCircleOutline}
            className="ReportDamageModal-step4-end-icon"
          />
          <div className="ReportDamageModal-step4-end-text">
            Merci !<br />
            Le dommage a bien été ajouté
          </div>
        </div>
      </IonModal>

      <IonRow className="ReportDamageModal-step4-title">
        {selectedElement
          ? vehiclePart?.title
          : side === "Inside"
          ? "Cabine"
          : "Intérieur"}
      </IonRow>
      <IonRow className="ReportDamageModal-step4-subtitle">
        {damageTypeOptions
          ?.filter((el) => damageList[el.name])
          .map((el) => {
            return el.label;
          })
          .join(", ")}
      </IonRow>
      <IonRow className="ReportDamageModal-step4-description">
        {description}
      </IonRow>
      {imageUrl ? (
        <IonRow className="ReportDamageModal-step4-imagecontainer">
          <IonAvatar className="ReportDamageModal-step4-image">
            <IonImg
              src={imageUrl}
              className="ReportDamageModal-step4-image"
              alt="DamagePhoto"
            />
          </IonAvatar>
        </IonRow>
      ) : null}

      <div className="ReportDamageModal-footer">
        <IonButton
          onClick={async () => takePicture()}
          className="ReportDamageModal-step4-link"
        >
          Reprendre la photo
        </IonButton>
        {Object.values(damageList).some((value) => value) ? (
          <IonButton
            color={"success"}
            expand="block"
            onClick={async () => {
              setStoreLoading(true);
              await storeDamage();
              setStoreLoading(false);
              setFinishModalIsOpen(true);
            }}
            className="ReportDamageModal-button_success"
          >
            Valider le nouveau dommage
            {storeLoading ? (
              <IonSpinner
                name="circular"
                slot="end"
                class="ReportDamageModal-loader"
              ></IonSpinner>
            ) : (
              <IonIcon icon={arrowForward} slot="end" />
            )}
          </IonButton>
        ) : null}
      </div>
    </>
  );
};

export default Step4;
